import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import LeadService from "../Lead/Controller/CommunicationController";
import { ThemeContext } from "../Layout/Theme/ThemeContext";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Draggable from 'react-draggable';
import Swal from 'sweetalert2';

function SendEmail({ onClose, ToEmail, pdfAttachment, ReportName = "JobCostReport.pdf" }) {
    debugger;
    const { theme } = useContext(ThemeContext);
    let accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";

    const [pdfUrl, setPdfUrl] = useState(null); // Store PDF URL
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        ID: 0,
        vc_Subject: '',
        vc_Description: '',
        vc_From: localStorage.getItem('Email'),
        vc_To: ToEmail,
        vc_CC: '',
        ClientID: 0,
        UserID: 0,
        attachment: ""
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (pdfAttachment) {
            const pdfFileUrl = URL.createObjectURL(pdfAttachment);
            setPdfUrl(pdfFileUrl);
        }
    }, [pdfAttachment]);

    const handleFieldChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleEditorChange = (content) => {
        setFormData({ ...formData, vc_Description: content });
    };


    const handleFormSubmit = async (event) => {

        event.preventDefault();
        setLoading(true);
        console.log("Form Data Before Sending:", formData);

        const errors = {};
        if (!formData.vc_Description || formData.vc_Description === "") {
            errors.vc_Description = "This field is required";
        }
        if (!isValidEmail(formData.vc_From)) {
            errors.vc_From = "Please enter a valid email address";
        }
        if (!isValidEmail(formData.vc_To)) {
            errors.vc_To = "Please enter a valid email address";
        }
        if (formData.vc_CC && !isValidEmail(formData.vc_CC)) {
            errors.vc_CC = "Please enter a valid email address";
        }

        setErrors(errors);
        if (Object.keys(errors).length === 0) {
            try {

                await LeadService.LeadSendEmailAttachment(formData, pdfAttachment);
                setLoading(false);
                localStorage.setItem('HasRecordUpdated', "1");
                Swal.fire("Success", "Email sent successfully.", "success");
                onClose();
            } catch (error) {
                setLoading(false);
                console.error("❌ Error sending email:", error);
                Swal.fire("Error", "Failed to send email.", "error");
            }
        }
        setLoading(false);
    };


    const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    return (
        <div>
            {loading && (
                <div class="loading">
                    <div class="d-table">
                        <div class="d-tablecell">
                            <span class="loader">
                                <span class="loader-inner"></span>
                            </span>
                        </div>
                    </div>
                </div>
            )}
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade customerHistoryModal show d-block" tabIndex="-1" aria-labelledby="customerHistoryModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-header" cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p"
                            bounds={{ top: 0, bottom: window.innerHeight - 400 }}>
                            <div className="modal-content">
                                <div className={`modal-header ${accordTheme}`}>
                                    <h5 className="modal-title">Send Email</h5>
                                    <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="row mb-3" style={{ marginLeft: "5px", marginRight: "0px", marginTop: "10px" }}>
                                        <label className="col-sm-2 col-form-label">From</label>
                                        <div className="col-sm-4">
                                            <input type="text" className="form-control" name="vc_From" value={formData.vc_From} onChange={handleFieldChange} />
                                            {errors.vc_From && <div style={{ color: 'red' }}>{errors.vc_From}</div>}
                                        </div>
                                    </div>
                                    <div className="row mb-3" style={{ marginLeft: "5px", marginRight: "0px" }}>
                                        <label className="col-sm-2 col-form-label">To</label>
                                        <div className="col-sm-4">
                                            <input type="text" className="form-control" name="vc_To" value={formData.vc_To} onChange={handleFieldChange} />
                                            {errors.vc_To && <div style={{ color: 'red' }}>{errors.vc_To}</div>}
                                        </div>
                                    </div>
                                    <div className="row mb-3" style={{ marginLeft: "5px", marginRight: "0px" }}>
                                        <label className="col-sm-2 col-form-label">Subject</label>
                                        <div className="col-sm-10">
                                            <input type="text" className="form-control" name="vc_Subject" value={formData.vc_Subject} onChange={handleFieldChange} />
                                            {errors.vc_Subject && <div style={{ color: 'red' }}>{errors.vc_Subject}</div>}
                                        </div>
                                    </div>

                                    <div className="row mb-3" style={{ marginLeft: "5px", marginRight: "0px" }}>
                                        <label className="col-sm-2 col-form-label">Message</label>
                                        <div className="col-sm-10">
                                            <ReactQuill value={formData.vc_Description} onChange={handleEditorChange} theme="snow" />
                                            {errors.vc_Description && <div style={{ color: 'red' }}>{errors.vc_Description}</div>}
                                        </div>
                                    </div>

                                    {/* Display Attached PDF */}
                                    {pdfAttachment && (
                                        <div className="row mb-3" style={{ marginLeft: "5px", marginRight: "0px" }}>
                                            <label className="col-sm-2 col-form-label">Attachment:</label>
                                            <div className="col-sm-10">
                                                <div className="d-flex align-items-center">

                                                    <a
                                                        href={pdfUrl}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="btn btn-link btn-sm ms-2"
                                                    >
                                                        {ReportName}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button type="submit" className="btn btn-primary">Send</button>
                                    <button className="btn btn-secondary" type="button" onClick={onClose}>Close</button>
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default SendEmail;
